import type { FaireProductEntity } from "../../entity_types/product";

export const p_2q878h29b7: FaireProductEntity = {
  token: "p_2q878h29b7",
  type: "product",
  name: "Rope Detail Zip Hoodie & Wide Leg Sweatpant Set",
  brandToken: "b_75jdpu9nvf",
  brandName: "Rehab Lab",
  imageUrl:
    "https://cdn.faire.com/fastly/cef03b00913bb0b07c5f856a2264395011df40b269ac182b67880e2dae8e8885.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bfefba5075726d7f4ef829d4dfd4751a5c3b930ce21a8eb0d63343f7fd3db930.jpeg",
    "https://cdn.faire.com/fastly/58d10ac9cb5e7d6bdd40c38174a1acda0608b1b7978ff09e1d07ef5951b8c923.jpeg",
    "https://cdn.faire.com/fastly/77206c3a96100013ee47eca9821bf0857cbd82cf6bd744622fe081c92ae10c7e.jpeg",
    "https://cdn.faire.com/fastly/0e0446babf564de5299a33ad107e2f49f5af780a1eac53e7d3cd5cc543e0e35a.jpeg",
    "https://cdn.faire.com/fastly/411439e71d2f079d9fea9d3c47f67070f6d017b0c6cb3fff0ffe982e9abc38ee.jpeg",
    "https://cdn.faire.com/fastly/351febdd6f1aee00d34efc6790d4acbcf018783f1917bfeab07086ff98ba3bba.jpeg",
    "https://cdn.faire.com/fastly/928b27ff2ce7479fda30dadbba06a86b4618b94350e6ada9949ca61224f9178a.jpeg",
  ],
  priceDollars: 39.25,
  description:
    "A fresh take on off-duty comfort with an avant-street edge. This matching zip-up hoodie and wide-leg sweatpant set elevates the classic fleece co-ord with statement rope details that cinch the waist and tie effortlessly at the front. The cropped hoodie and extra-relaxed pants create a bold silhouette that feels laid-back yet distinctly fashion-forward - perfect for styling up your streetwear rotation.\n\n* Two-piece matching set: cropped zip hoodie + wide-leg sweatpants\n\n* Soft fleece sweatshirt fabric with relaxed drape\n\n* Statement rope drawstring detail at waist and pant\n\n* Elastic waistband for comfort and easy pull-on fit\n\n* Oversized hood and dropped shoulders for a laid-back vibe\n\n* Extra-wide leg silhouette for dramatic flow\n\n* Street-luxe reimagining of the everyday tracksuit",
  tags: [],
  msrpDollars: 78.5,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:48:35.267Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
